import { render, staticRenderFns } from "./DispositivoModal.vue?vue&type=template&id=20eb5a66&"
import script from "./DispositivoModal.vue?vue&type=script&lang=js&"
export * from "./DispositivoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports